site.megamenuImage = {
	init:function() {
		const $mainmenu = $('#mainmenu'),
			$body = $('body');

		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="megamenuWrap"><div class="contentWrap" /></div></div>');

		$('.megamenu .megamenuWrap').after('<div class="megamenuBg"></div>');
		$('.megamenu').after('<div class="storeCategoryMenu"><button class="storeCategoryMenuBack">Til baka í aðalvalmynd</button><div class="storeCategoryMenuWrap"></div></div>');

		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});


		$('.level1.children > a',$mainmenu).on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				const isOpen = $(this).parent().hasClass('open');
				site.megamenuImage.closeAll();
				if (!isOpen) {
					$(this).parent().addClass('open');
					$body.addClass('megamenu-open');
				} else {
					setTimeout(function() {
						$body.removeClass('megamenu-open');
					}, 400);
				}
			}
		});

		$body.on('click', function () {
			if ($body.is('.megamenu-open')) {
				site.megamenuImage.closeAll();
				setTimeout(function() {
					$('body').removeClass('megamenu-open');
					$('body').removeClass('storeCategoryMenuOpen');
				}, 400);
			}
		});

		site.megamenuImage.initStoreMenu();
	},

	closeAll: function() {
		const $mainmenu = $('#mainmenu');
		$('body').removeClass('storeCategoryMenuOpen');
		$('.level1.open', $mainmenu).removeClass('open');
	},

	initStoreMenu() {
		const storeSitemapItems = document.querySelectorAll('.si a[data-storeCategory]');
		if (!storeSitemapItems.length) {
			return;
		}
		storeSitemapItems.forEach((item) => {
			item.addEventListener('click', (e) => {

				e.preventDefault();
				const storeCategoryCodename = item.dataset.storecategory;
				const fallbackHref = item.getAttribute('href');
				const fetchUrl = `/_/is/store/index/category/${storeCategoryCodename}`;
				fetch(fetchUrl)
					.then(response => response.text())
					.then(text => site.megamenuImage.updateStoreMenu(item, text, fallbackHref));
			});
		});

		const storeMenuBack = document.querySelector('.storeCategoryMenuBack');
		if (!storeMenuBack) {
			return;
		}
		storeMenuBack.addEventListener('click', (e) => {
			document.body.classList.remove('storeCategoryMenuOpen');
			site.megamenuImage.closeCategoryMenu();
		});

		document.body.addEventListener('keydown', (e) => {
			if (document.body.classList.contains('tabbing') && e.keyCode === 27) {
				document.body.classList.remove('megamenu-open');
				document.body.classList.remove('storeCategoryMenuOpen');
				site.megamenuImage.closeCategoryMenu();
				site.megamenuImage.closeAll();
			}
		});
	},

	updateStoreMenu(item, text, fallbackHref) {
		const $item = $(item),
			$text = $(text),
			closestLevel1 = $item.closest('.level1'),
			closestCategoryMenu = closestLevel1.find('.storeCategoryMenu'),
			closestCategoryMenuWrap = closestCategoryMenu.find('.storeCategoryMenuWrap');
		if (!closestCategoryMenuWrap.length) {
			return;
		}
		site.megamenuImage.closeCategoryMenu();
		site.megamenuImage.openCategoryMenu(closestCategoryMenu[0]);

		const title = $text.find('.title h1').text(),
			categories = $text.find('.storeCardList--categories'),
			newTitle = document.createElement('div');
		if (!categories.length) {
			window.location.href = fallbackHref;
			return;
		}
		newTitle.textContent = title;
		newTitle.classList.add('storeCategoryMenuTitle');
		closestCategoryMenuWrap.html(newTitle.outerHTML + categories[0].outerHTML);

		document.body.classList.add('storeCategoryMenuOpen')

		$('img.responsive').responsiveImg();
	},

	closeCategoryMenu(menu) {
		if (!menu) {
			menu = document.querySelectorAll('.storeCategoryMenu');
		}
		if (menu.length) {
			menu.forEach((menuInstance) => {
				menuInstance.classList.remove('open');
			})
		} else {
			menu.classList.remove('open');
		}
	},

	openCategoryMenu(menu) {
		menu.classList.add('open');
	}
};
site.inits.push('site.megamenuImage.init()');
